// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__-ftER","right":"styles_right__2APxs"};